import moment from "moment";

import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Modal } from "@/Common/Components/Modals/Modal";
import { NameHelper } from "@/Common/Helpers/NameHelper";
import { Patient } from "@/Common/Models/Patient/Patient";

import img_p_banner_icon_100 from "@/Globals/_images/p-banner-icon-100.png";

interface IDuplicatePatientWarningPopupProps {
    existingPatients: Patient[];
    onLink: (patient: Patient) => void;
    onContinue: () => void;
    onClose: () => void;
}

class DuplicatePatientWarningPopupState {
    public selectedPerson: Patient;
}

class DuplicatePatientWarningPopup extends BaseReactComponent<IDuplicatePatientWarningPopupProps, DuplicatePatientWarningPopupState> {
    constructor(props: IDuplicatePatientWarningPopupProps) {
        super(props);

        const initialState = new DuplicatePatientWarningPopupState();
        initialState.selectedPerson = props.existingPatients?.length === 1 ? props.existingPatients[0] : null;
        this.state = initialState;
    }

    public render(): JSX.Element {
        if (isArrayNullOrUndefinedOrEmpty(this.props.existingPatients))
            return null;

        return (
            <Modal
                showOverlay
                showX
                disableOverlayClose
                title={cacheStore.GetString("WarningLabel")}
                width={650}
                onClose={() => this.props.onClose && this.props.onClose()}
                footer={this.renderFooter()}
            >
                <p style={{ padding: "5px" }}>{cacheStore.GetString("DuplicateSentence1Label")}</p>
                <div className="pa-selected-items-list" style={{ maxHeight: "400px", overflowY: "auto" }}>
                    {this.props.existingPatients.map(x => this.renderExistingPatient(x))}
                </div>
            </Modal>
        );
    }

    private renderFooter(): JSX.Element {
        return (
            <div className="flex-container" style={{ "justifyContent": "flex-end" }}>
                <div style={{ "marginLeft": "5px" }}>
                    <button className="btn btn-default" onClick={() => this.props.onContinue && this.props.onContinue()}>
                        {cacheStore.GetString("ContinueLabel")}
                    </button>
                </div>
                <div style={{ "marginLeft": "5px" }}>
                    <button
                        className="btn btn-primary"
                        disabled={!this.state.selectedPerson}
                        onClick={() => this.props.onLink && this.props.onLink(this.state.selectedPerson)}
                    >
                        {cacheStore.GetString("LinkLabel")}
                    </button>
                </div>
            </div>
        );
    }

    private renderExistingPatient(patient: Patient): JSX.Element {
        let address, healthCard;
        if (!isArrayNullOrUndefinedOrEmpty(patient.Addresses))
            address = patient.GetFormattedAddress();

        if (!isArrayNullOrUndefinedOrEmpty(patient.HealthCards))
            healthCard = patient.GetFormattedNAM();

        let name = patient.GetFormattedNameWithPrefix();

        let isSelected = this.state.selectedPerson && this.state.selectedPerson.IndividualResponse.Contact_id === patient.IndividualResponse.Contact_id;

        return (
            <div key={patient.IndividualResponse.Contact_id} className={`flex-container selectable ${isSelected ? "selected" : "notselected"}`} onClick={() => this.mutateState(s => s.selectedPerson = patient)}>
                <div className="flex-col r1">
                    <img title={name} src={img_p_banner_icon_100} style={{ width: "48px" }} alt={name} />
                </div>
                <div style={{ width: "5px" }} />

                <div className="flex-col r2">
                    <h4 className="light-blue">
                        <span>{NameHelper.formatFullNameForHasName(patient.IndividualResponse)}</span><span className="myle-icon-16 female" />
                    </h4>
                    <ul>
                        <li><strong>{sessionStore.getDefaultHealthCardLabel()} </strong><span>{healthCard}</span></li>
                        <li><strong>{cacheStore.GetString("DateofBirthLabel")} </strong><span>{this.renderDateOfBirthAndAge(patient)}</span></li>
                    </ul>
                </div>

                <div className="flex-col r3">
                    <ul>
                        {this.renderPhones(patient)}
                        {address && <li><span className="myle-icon-16 pin" /><span className="content-text">{address}</span></li>}
                    </ul>
                </div>
            </div>
        );
    }

    private renderPhones(patient: Patient): JSX.Element[] {
        return patient.Phones?.map((phone, i) => {
            if (phone)
                return (
                    <li key={phone.ContactPoint_id}>
                        <span className="myle-icon-16 phone" />
                        <span className="content-text">
                            {patient.GetFormattedPhonesByPriorityWithPosition(i)}
                        </span>
                    </li>
                );
        });
    }

    private renderDateOfBirthAndAge(patient: Patient): JSX.Element {
        let dateOfBirth = patient.IndividualResponse.DateOfBirth ?
            moment(patient.IndividualResponse.DateOfBirth).format("YYYY/MM/DD")
            : "";

        return <span>{dateOfBirth} {patient.GetFormattedAge()}</span>;
    }
}

export { DuplicatePatientWarningPopup };
